<template>
    <main>
        <v-container :loading="loading" class="grey lighten-4 fill-height" fluid>
            <v-row>
                <v-col cols="12" sm="8" md="4" class="mx-auto" >
                 <v-card class="elevation-12 ma-3 pa-6 mx-auto">
                <v-form ref="form" :loading="loading">
                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Din mail"
                    required
                    outlined
                ></v-text-field>
                <v-btn @click="submit" block>
                    Skicka mail
                </v-btn>
            </v-form>
            </v-card>
                </v-col>
            </v-row>
        </v-container>
    </main>
</template>

<script>
import store from "../../store";
export default {
    name: "passwordreset",
    data: () => ({
        store: store,
        email: "",
        loading: false,
        emailRules: [
            v => !!v || "Din mail krävs",
            v => /.+@.+\..+/.test(v) || "Email måste vara giltig"
        ]
    }),
    methods: {
        submit: async function() {
            this.loading = true;
            if (this.$refs.form.validate()) {
                let bodyFormData = new FormData();
                bodyFormData.set("email", this.email);
                var config = {
                    method: "post",
                    url: "",
                    headers: {
                        "Content-Type": "application/form-data;charset=utf-8",
                        "Access-Control-Allow-Origin": "*",
                        Accept: "*/*"
                    },
                    data: bodyFormData
                };
                await this.store.dispatch("passreset", config);
                this.loading = false;
                this.$router.replace("setpassword");
            }
        }
    }
};
</script>

<style></style>
